import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
//import { DoctorsService } from "./Services/DoctorsService";
import { searchDoctors } from "../Doctors/Services/searchDoctors";
import Swal from "sweetalert2";

export default function SearchDoctors() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isSearching, setIsSearching] = useState(false);

    // Get initial results from navigation state
    //const { results } = location.state || { results: [] };

    // --- NEW STATE FOR FILTERING/SORTING ---
    const [displayResults, setDisplayResults] = useState([]);
    const [sortLabel, setSortLabel] = useState("Price (Low to High)");
    //const [locations, setLocations] = useState('');
    const [keyword, setKeyword] = useState('');

    // Sync displayResults when search results from location.state change
    useEffect(() => {
        if (location.state?.results) {
            setDisplayResults(location.state.results);
        }
    }, [location.state]);

    useEffect(() => {
        const scriptUrls = [
            "assets/js/jquery-3.7.1.min.js",
            "assets/js/bootstrap.bundle.min.js",
            "assets/plugins/select2/js/select2.min.js",
            "assets/js/feather.min.js",
            "assets/js/moment.min.js",
            "assets/js/bootstrap-datetimepicker.min.js",
            "assets/js/script.js"
        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.async = false;
                    script.onload = () => {
                        console.log(`Loaded: ${url}`);
                        resolve();
                    };
                    script.onerror = () => {
                        console.error(`Failed to load: ${url}`);
                        reject();
                    };
                    document.body.appendChild(script);
                });
            }

            if (!isCancelled) {
                if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                    window.$('.datetimepicker').datetimepicker();
                }

                if (typeof window.initBackToTop === 'function') {
                    window.initBackToTop();
                }

                console.log('All scripts loaded and initialized.');
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);

    const handleViewDoctor = async (doctorId) => {
        navigate(`/doctor-profile?query=${doctorId}`);
    }
    const [isOpen, setIsOpen] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        const combinedKeyword = `${keyword}`.trim();
        setIsSearching(true);
        try {
            //sessionStorage.clear();
            const response = await searchDoctors(combinedKeyword);
            console.log("Search results:", response.data);
            // We flat() here to ensure we are passing a clean array to the state
            const freshData = response.data.data.flat();
            navigate("/search-doctors", { state: { results: freshData } });
        } catch (error) {
            console.error("Search error:", error);
        }
        finally {
           setIsSearching(false);   // ← Stop loading (always runs)
        }
    };

    const handleViewCompany = async (companyId) => {
        navigate(`/company-profile?query=${companyId}`);
    }

    // --- SORTING LOGIC ---
    const handleSort = (type) => {
        const sortedArray = [...displayResults];
        if (type === 'lowToHigh') {
            sortedArray.sort((a, b) => a.consultationFee - b.consultationFee);
            setSortLabel("Price (Low to High)");
        } else if (type === 'highToLow') {
            sortedArray.sort((a, b) => b.consultationFee - a.consultationFee);
            setSortLabel("Price (High to Low)");
        }
        setDisplayResults(sortedArray);
        setIsOpen(false);
    };

    function toTitleCase(str) {
        if (!str) return "";
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    return (
        <>
            <style>{`

          .content {
 padding-top:2px;
 margin-top:2px;
}
 
        .search-box-one {
  max-width: 100%;
  margin: 0 auto;
  padding: 0px !important;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
//   border: 2px solid #1ea7fd;
  border-radius: 60px;
  background: #fff;
}

/* Input blocks */
.search-field {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.search-input-box {
  border: none;
  outline: none;
  width: 100%;
  font-size: 15px;
}

/* Search button */
.search-btn-box button {
  padding: 12px 26px;
  border-radius: 30px;
  border: none;
  background: linear-gradient(90.08deg, #0E82FD 0.09%, #06AED4 70.28%) !important;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}
@media (max-width: 768px) {

.content {
    padding-top:15px;
    margin-top:5px;
}
   
  .search-form {
    flex-direction: column;
    border-radius: 20px;
    padding: 12px;
  }

  .search-field {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 14px;
    background: #fff;
  }

  .search-btn-box {
    width: 100%;
  }

  .search-btn-box button {
    width: 100%;
    border-radius: 14px;
    padding: 14px;
  }
}
  .card-img img{
    height:250px;
  }
`}
            </style>
            <div>
                {/* Breadcrumb */}
                <div className="breadcrumb-bar overflow-visible">
                    <div className="container">
                        <div className="row align-items-center inner-banner">
                            <div className="col-md-12 col-12 text-center">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    {/* <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}><i className="isax isax-home-15" /></a></li>
                                    <li className="breadcrumb-item">Doctor</li>
                                    <li className="breadcrumb-item active">Doctor Lists</li>
                                </ol> */}
                                    <h2 className="breadcrumb-title">Doctor according to your search...</h2>
                                </nav>
                            </div>
                        </div>
                        <div className="bg-primary-gradient rounded-pill doctors-search-box">
                            {/* <div className="search-box-one rounded-pill">
                            <form onSubmit={handleSearch}>
                                <div className="search-input search-line">
                                    <i className="isax isax-hospital5 bficon" />
                                    <div className=" mb-0">
                                        <input type="text" className="form-control"
                                            value={keyword}
                                            onChange={(e) => setKeyword(e.target.value)}
                                            placeholder="Search for Doctors, Hospitals, Clinics" />
                                    </div>
                                </div>
                                <div className="flex-break"></div>
                                <div className="search-input search-map-line">
                                    <i className="isax isax-location5"/>
                                    <div className=" mb-0">
                                        <input type="text" className="form-control"
                                            value={locations}
                                            onChange={(e) => setLocations(e.target.value)}
                                            placeholder="Location" />
                                    </div>
                                </div>

                                <div className="form-search-btn">
                                    <button className="btn btn-primary d-inline-flex align-items-center rounded-pill" type="submit"><i className="isax isax-search-normal-15 me-2" />Search</button>
                                </div>
                            </form>
                        </div> */}
                            <div className="search-box-one rounded-pill">
                                <form className="search-form " onSubmit={handleSearch}>
                                    <div className="search-field keyword-field">
                                        <i className="isax isax-hospital5 bficon" />
                                        <input
                                            type="text"
                                            className="search-input-box"
                                            value={keyword}
                                            onChange={(e) => setKeyword(e.target.value)}
                                            placeholder="Search for Doctors, Hospitals, Clinics"
                                        />
                                    </div>

                                    {/* <div className="search-field location-field">
      <i className="isax isax-location5" />
      <input
        type="text"
        className="search-input-box"
        value={locations}
        onChange={(e) => setLocations(e.target.value)}
        placeholder="Location"
      />
    </div> */}

                                    <div className="search-btn-box">
                                        <button type="submit" disabled={isSearching}>
                                            
                                            {isSearching ? (
            <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Searching...
            </>
        ) : (
            <>
                <i className="isax isax-search-normal-15 me-2" />
                Search
            </>
        )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="breadcrumb-bg">
                        <img src="assets/img/bg/breadcrumb-bg-01.png" alt="img" className="breadcrumb-bg-01" />
                        <img src="assets/img/bg/breadcrumb-bg-02.png" alt="img" className="breadcrumb-bg-02" />
                        <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-03" />
                        <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-04" />
                    </div>
                </div>
                {/* /Breadcrumb */}
                <div className="content mt-5">
                    <div className="container">
                        <div className="row mt-4">
                            <div className="col-md-6">
                                <div className="mb-4">
                                    <h3>Showing <span className="text-secondary">{displayResults.length}</span> Hospitals/Clinics/Doctors For You</h3>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-center justify-content-end mb-4">

                                    <div className="dropdown header-dropdown">
                                        <button
                                            type="button"
                                            style={{ backgroundColor: "transparent" }}
                                            className="dropdown-toggle sort-dropdown"
                                            onClick={() => { setIsOpen(!isOpen); }}
                                            aria-expanded={isOpen}
                                        >
                                            <span>Sort By</span> {sortLabel}
                                        </button>
                                        {isOpen && (
                                            <div className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}>
                                                <button className="dropdown-item" onClick={() => handleSort('lowToHigh')}>
                                                    Price (Low to High)
                                                </button>
                                                <button className="dropdown-item" onClick={() => handleSort('highToLow')}>
                                                    Price (High to Low)
                                                </button>
                                            </div>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="filter_inputs">
                            <div className="row align-items-center gy-3">
                                <div className="col-lg-9 mb-4">
                                    <div className="row gx-3">
                                        <div className="col-md col-sm-4 col-6">
                                            <div>
                                                <select className="select form-control">
                                                    <option>Specialities</option>
                                                    <option>Urology</option>
                                                    <option>Psychiatry</option>
                                                    <option>Psychiatry</option>
                                                    <option>Cardiology</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md col-sm-4 col-6">
                                            <div>
                                                <select className="select form-control">
                                                    <option>Hospitals</option>
                                                    <option>Cleveland Clinic</option>
                                                    <option>Apollo Hospital</option>
                                                    <option>Apollo Hospital</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md col-sm-4 col-6">
                                            <div>
                                                <select className="select form-control">
                                                    <option>Doctors</option>
                                                    <option>Dr. Michael Brown</option>
                                                    <option>Dr. Nicholas Tello</option>
                                                    <option>Dr. Harold Bryant</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md col-sm-4 col-6">
                                            <div>
                                                <select className="select form-control">
                                                    <option>Reviews</option>
                                                    <option>5 Star</option>
                                                    <option>4 Star</option>
                                                    <option>3 Star</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md col-sm-4 col-6">
                                            <div>
                                                <select className="select form-control">
                                                    <option>Clinic</option>
                                                    <option>Bright Smiles Dental Clinic</option>
                                                    <option>Family Care Clinic</option>
                                                    <option>Express Health Clinic</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-4">
                                    <div className="text-end">
                                        <a href="/" role="button" className="fw-medium text-secondary text-decoration-underline" onClick={(e) => { e.preventDefault() }}>Clear All</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {displayResults.map((doctor, index) => (
                                <div className="col-xxl-3 col-lg-4 col-md-6" key={index}>
                                    <div className="card">
                                        <div className="card-img card-img-hover" >
                                            <a href="/" role="button" onClick={(e) => {
                                                            e.preventDefault();
                                                            doctor.type === 'user' ? ((doctor?.showIdentity === 'Y') && doctor?.kycAccept === 'Y'
                                                                ? handleViewDoctor(doctor.userId)
                                                                : Swal.fire({
                                                                    title: 'Warning!',
                                                                    text: 'Identity is not verified.',
                                                                    icon: 'warning',
                                                                    confirmButtonColor: '#566fe2',
                                                                    customClass: {
                                                                        title: 'swal-title-small',
                                                                        popup: 'swal-popup-small',
                                                                        confirmButton: 'swal-button-small'
                                                                    }
                                                                })) : ((doctor?.showIdentity === 'Y') ?
                                                                    handleViewCompany(doctor.userId) : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                            title: 'swal-title-small',
                                                                            popup: 'swal-popup-small',
                                                                            confirmButton: 'swal-button-small'
                                                                        }
                                                                    }))
                                                        }}>
                                                <img
                                                    src={doctor.type === 'user' ? (doctor.photo ? `${serverConfig.BASE_URL}/uploads/${doctor.photo}` :
                                                        `${serverConfig.BASE_URL}/uploads/demo.jpg`) : (doctor.photo ? `${serverConfig.BASE_URL}/uploads/company/${doctor.photo}` :
                                                            `${serverConfig.BASE_URL}/uploads/demo.jpg`)}
                                                    alt={doctor.type === 'user' ? "Doctor" : "Hospital"}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null; // prevents infinite loop
                                                        e.target.src = doctor.type === 'user' ? "assets/img/doctor.png" : "assets/img/hospital.jpg";
                                                    }}
                                                />
                                            </a>
                                            <div className="grid-overlay-item d-flex align-items-center justify-content-between">
                                                <span className="badge bg-orange">
                                                    {/* <i className="fa-solid fa-star me-1" />5.0 */}
                                                </span>
                                                {/* <a href="/" role="button"  onClick={(e)=>{e.preventDefault()}}className="fav-icon">
                                                 <i className="fa fa-heart" />
                                            </a> */}
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="d-flex active-bar align-items-center justify-content-between p-3">
                                                <a href="/" role="button" onClick={(e) => { e.preventDefault() }} className="text-indigo fw-medium fs-14">
                                                    {doctor.specialization}
                                                </a>
                                                {(doctor?.showIdentity !== 'Y') ? <span className="badge bg-danger-light d-inline-flex align-items-center">
                                                    <i className="fa-solid fa-circle fs-5 me-1" style={{ color: "red" }} />
                                                    Not verified
                                                </span> : doctor.type === 'user' && doctor.availableToday === 'Y' ?
                                                    <span className="badge bg-success-light d-inline-flex align-items-center">
                                                        <i className="fa-solid fa-circle fs-5 me-1" style={{ color: (doctor.availableToday === 'Y') ? "green" : "red" }} />
                                                        Available
                                                    </span>
                                                    : <></>}
                                            </div>
                                            <div className="p-3 pt-0">
                                                <div className="doctor-info-detail mb-3 pb-3">
                                                    <h3 className="mb-1">
                                                        <a href="/" role="button" onClick={(e) => {
                                                            e.preventDefault();
                                                            doctor.type === 'user' ? ((doctor?.showIdentity === 'Y') && doctor?.kycAccept === 'Y'
                                                                ? handleViewDoctor(doctor.userId)
                                                                : Swal.fire({
                                                                    title: 'Warning!',
                                                                    text: 'Identity is not verified.',
                                                                    icon: 'warning',
                                                                    confirmButtonColor: '#566fe2',
                                                                    customClass: {
                                                                        title: 'swal-title-small',
                                                                        popup: 'swal-popup-small',
                                                                        confirmButton: 'swal-button-small'
                                                                    }
                                                                })) : ((doctor?.showIdentity === 'Y') ?
                                                                    handleViewCompany(doctor.userId) : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                            title: 'swal-title-small',
                                                                            popup: 'swal-popup-small',
                                                                            confirmButton: 'swal-button-small'
                                                                        }
                                                                    }))
                                                        }}>
                                                            {doctor.type === 'user' ? "Dr. " + toTitleCase(doctor.name) : toTitleCase(doctor.name)}</a>
                                                    </h3>
                                                    <div className="d-flex align-items-center">
                                                        <p className="d-flex align-items-center mb-0 fs-14">
                                                            {doctor.qualification}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <p className="d-flex align-items-center mb-0 fs-14">
                                                            <i className="isax isax-location me-2" />
                                                            {doctor.address || "Unknown"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                        {doctor.type === 'user' ? <>
                                                            <p className="mb-1" style={{ color: 'blue', fontWeight: '600' }}>Consultation Fees</p>
                                                            <h3 className="text-orange">&#8377; {doctor.consultationFee}</h3>
                                                        </> : <></>}

                                                    </div>
                                                    <button className="btn btn-md btn-dark d-inline-flex align-items-center rounded-pill"
                                                        disabled={doctor?.showIdentity !== 'Y' ? true : false}
                                                        onClick={() => {

                                                            doctor.type === 'user' ? ((doctor?.showIdentity === 'Y')&& doctor?.kycAccept === 'Y'
                                                                ? handleViewDoctor(doctor.userId)
                                                                : Swal.fire({
                                                                    title: 'Warning!',
                                                                    text: 'Identity is not verified.',
                                                                    icon: 'warning',
                                                                    confirmButtonColor: '#566fe2',
                                                                    customClass: {
                                                                        title: 'swal-title-small',
                                                                        popup: 'swal-popup-small',
                                                                        confirmButton: 'swal-button-small'
                                                                    }
                                                                })) : ((doctor?.showIdentity === 'Y') ?
                                                                    handleViewCompany(doctor.userId) : Swal.fire({
                                                                        title: 'Warning!',
                                                                        text: 'Identity is not verified.',
                                                                        icon: 'warning',
                                                                        confirmButtonColor: '#566fe2',
                                                                        customClass: {
                                                                            title: 'swal-title-small',
                                                                            popup: 'swal-popup-small',
                                                                            confirmButton: 'swal-button-small'
                                                                        }
                                                                    }))
                                                        }}>
                                                        <i className="isax isax-calendar-1 me-2" />
                                                        Book Now
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}